export enum OrgSelfServeMigrationEvent {
    CancelMigration = 'OrgSelfServeMigration.CancelMigration',
    OpenMigration = 'OrgSelfServeMigration.OpenMigration',
    ReadMore = 'OrgSelfServeMigration.ReadMore',
    RequestMigration = 'OrgSelfServeMigration.RequestMigration',
    SelectMigrationWindow = 'OrgSelfServeMigration.SelectMigrationWindow',
    SelectNewRegion = 'OrgSelfServeMigration.SelectNewRegion',
    ViewMigrationDetails = 'OrgSelfServeMigration.ViewMigrationDetails',
}
